export default "__VITE_ASSET__088ab038__"